import { reactive, ref } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import useDiscussionService from '@/services/DiscussionService';

type Props = SetupProps<typeof SharedDiscussionsSetupService.props>

export default class SharedDiscussionsSetupService extends BaseSetupService<Props> {
	static readonly props = undefined;

	readonly _discussionsList = ref<HTMLElement>();
	readonly _discussions = ref<(OrionChat)[]>([]);

	readonly discussionService = useDiscussionService();
	private readonly state = reactive({
		firstFetch: false,
		displayDiscussionList: false,
	});

	get displayDiscussionList () { return this.state.displayDiscussionList; }

	get displayDiscussionWrapper () {
		if (this.ui.onLayoutNavBottom)
			return !this.displayDiscussionList && !this.discussionService?.openedDiscussions.length;
		else return !this.displayDiscussionList;
	}

	get publicInstance () {
		return {
			_discussionsList: () => this._discussionsList,
			show: () => this.show(),
			hide: () => this.hide(),
			toggle: () => this.toggle(),
		};
	}


	constructor (props?: Props) {
		super(props);
	}

	protected onMounted () {
		this.discussionService?.startSignalRMessage();
		this.discussionService?.getUnreadMessagesIdsAsync(),
		this.discussionService?.registerDiscussionsComponent(this.publicInstance);
		this.registerBusEvent('check-unread-messages-in-dom', (discussionId) => {
			this._discussions.value.find(x => x.getDiscussionId() === discussionId)?.checkUnreadMessagesInDom();
		});
	}

	protected onBeforeUnmount (): void {
		this.discussionService?.leaveDiscussions();
		this.discussionService?.stopSignalRMessage();
	}


	async exeFirstFetchAsync () {
		if (!this.state.firstFetch) {
			this.state.firstFetch = true;
			await this.discussionService?.chat.fetchDiscussionsAsync();
		}
	}

	show () {
		this.state.displayDiscussionList = true;
		this.exeFirstFetchAsync();
	}

	hide () {
		this.state.displayDiscussionList = false;
	}

	toggle () {
		this.state.displayDiscussionList = !this.state.displayDiscussionList;
	}
}
